'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef, useRef, useEffect } from 'react';
import { fieldObserver } from './fieldObserver.js';
import { useMergeRefs } from '../../utilities/hooks/useMergeRefs/useMergeRefs.js';

/**
 * Field component, used to wrap a form field.
 *
 * @example
 * <Field>
 *   <Label>Kort beskrivelse</Label>
 *   <Field.Description>Beskrivelse</Field.Description>
 *   <Input />
 *   <ValidationMessage>Feilmelding</ValidationMessage>
 * </Field>
 */
const Field = forwardRef(function Field({ className, position, ...rest }, ref) {
    const fieldRef = useRef(null);
    const mergedRefs = useMergeRefs([fieldRef, ref]);
    useEffect(() => fieldObserver(fieldRef.current), []);
    return (jsx("div", { className: cl('ds-field', className), "data-position": position, ref: mergedRefs, ...rest }));
});

export { Field };
